import {ShareType} from 'components/Accommodation/ShareButton/constants'
import {SEARCH_ROUTE} from 'constants/index'
import {hasStickyOtaMode} from 'hooks/useOtaMode/sessionStore'
import {isNil, reject, toLower} from 'ramda'

import {getCookie} from '@vio/core/src/_web/utils/cookies'
import {isOtaModeProfile, OTA_MODE_PROFILE} from '@vio/core/src/profile'
import {
  OFFER_MODE_COOKIE,
  parseOfferMode
} from '@vio/core/src/profile/constants'

const trackedSourceTypes = new Set([
  ShareType.Email,
  ShareType.WhatsApp,
  ShareType.ShareLink
])

export type SearchProps = {
  hotelId: string
  checkIn?: string
  checkOut?: string
  rooms?: string
  component: string
}
export type ParamsTypes = SearchProps & {
  shareType: ShareType
}

export const createHotelShareUrl = ({
  hotelId,
  checkIn,
  checkOut,
  shareType,
  rooms,
  component = 'hoteldetails'
}: ParamsTypes) => {
  if (!hotelId) return null
  const {origin, searchParams} = new URL(window.location.href)
  // The link opens in a fresh tab where the sticky OTA flag (sessionStorage)
  // does not exist, so OTA mode must travel in the URL itself. The Offer mode
  // override is personal and never travels
  const isOtaMode =
    !parseOfferMode(getCookie(OFFER_MODE_COOKIE)) &&
    (isOtaModeProfile(searchParams.get('profile') ?? undefined) ||
      hasStickyOtaMode())
  const params = new URLSearchParams(
    reject(isNil, {
      hotelId,
      checkIn,
      checkOut,
      rooms,
      utm_medium: 'referral',
      utm_campaign: toLower(component),
      // we only want to add utm_source for specific share types
      ...(trackedSourceTypes.has(shareType) && {
        utm_source: toLower(shareType)
      }),
      ...(isOtaMode && {profile: OTA_MODE_PROFILE})
    })
  )
  return `${origin}${SEARCH_ROUTE}?${params.toString()}`
}
